import { prune, truncate } from "underscore.string";

export const safePrune = (text: string | null | undefined, len: number): string => {
  if (!text || text.length <= len) {
    return text || "";
  }

  const out = prune(text, len);
  if (out === "...") {
    return truncate(text, len);
  } else {
    return out;
  }
};
